"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { InitMuiLicense, Spinner } from "@climatepartner/components";
import { AuthProvider as FronteggAuthProvider, useAuth } from "@climatepartner/hooks";
import { getServiceUrls, mapServiceUrlsByAccess } from "@climatepartner/utils";
import { AuthenticationContext } from "../../providers/AuthenticationContext";
import { DashboardLayout } from "./DashboardLayout";
InitMuiLicense();
const POST_LOGOUT_REDIRECT_URI = "https://climatepartner.com";
const AppShellAuthProvider = (props) => {
    const { children, fronteggEnvironment } = props;
    const isEmployeeLogin = false;
    const { user, isAuthenticated, activeAccount, hasPermission, logout } = useAuth(isEmployeeLogin);
    const serviceUrls = getServiceUrls({ env: fronteggEnvironment, userHasPermission: hasPermission });
    const enabledServices = mapServiceUrlsByAccess(serviceUrls);
    const authenticationContextValue = useMemo(() => ({
        user,
        actions: {
            logout: () => logout(POST_LOGOUT_REDIRECT_URI),
            hasPermission,
        },
        enabledServices,
        activeAccount,
    }), [user, logout, hasPermission, enabledServices, activeAccount]);
    if (authenticationContextValue.user === null || !isAuthenticated || activeAccount === null) {
        return _jsx(Spinner, { isFixed: true });
    }
    return (_jsx(AuthenticationContext.Provider, { value: authenticationContextValue, children: children }));
};
const mapCimUrlToEnvironment = (environment) => {
    return {
        dev: "https://admin-frontend.dev.c12r.io",
        staging: "https://admin-frontend.stg.c12r.io",
        prod: "https://admin.climatepartner.com",
    }[environment];
};
export function AppShell(props) {
    const { children, fronteggEnvironment } = props;
    if (fronteggEnvironment !== undefined && ["dev", "staging", "prod"].includes(fronteggEnvironment)) {
        return (_jsx(FronteggAuthProvider, { environment: fronteggEnvironment, children: _jsx(AppShellAuthProvider, { fronteggEnvironment: fronteggEnvironment, children: _jsx(DashboardLayout, { ...props, cimUrl: mapCimUrlToEnvironment(fronteggEnvironment), children: children }) }) }));
    }
    throw new Error("Frontegg environment needs to be set to dev, staging, or prod.");
}
export default AppShell;
//# sourceMappingURL=AppShell.js.map